module.exports = __webpack_public_path__ + "b4c9bb8353dc6dafd0cf9584df63dd19.png";